import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Modal } from '../../modules/Modal';

import { tns } from 'tiny-slider';
import { PublicPage } from '../PublicPage';

export class ProductPage extends PublicPage {
    public static render(params: RouteParams): void {
        super.render(params);

        super._OpenMenu();
        ProductPage._addModalEventListeners();
        ProductPage._initImagesBehavior();
    }

    private static _addModalEventListeners(): void {
        const modalContents = document.querySelector('.modal-info');
        if (modalContents === null) {
            return;
        }

        const opensModal = Array.from(document.querySelectorAll<HTMLElement>('.opens-normative-modal'));
        opensModal.forEach((element) => {
            element.addEventListener('click', (e: MouseEvent) => {
                const normative = element.closest('.normative');
                const contentDataContainer = normative?.querySelector<HTMLElement>('.modal-content');
                const content = contentDataContainer?.querySelector<HTMLElement>('.modal-info-content');
                const icons = contentDataContainer?.querySelector<HTMLElement>('.modal-info-icons');

                Modal.open('Normativa', content ?? undefined, icons ?? undefined);
            });
        });
    }

    private static _initImagesBehavior(): void {
        ProductPage._initTinySlider();
        ProductPage._initLightGalleryGloves();
        ProductPage._initLightGalleryClothes();
        ProductPage._initClickZoom();
    }

    private static _initClickZoom(): void {
        const items = $('#images-carousel .item');
        items.on('click', function (e) {
            const item = $(this);
            const img = item.find('.img-wrapper');
            const target = $(e.target);
            if (target.hasClass('zoom-img')) {
                img.trigger('click');
            }
        });
    }

    private static _initTinySlider(): void {

        if($('#images-slider').length == 0){
            return;
        }

        const bigSlider = tns({
            loop: true,
            container: '#images-slider',
            items: 1,
            navAsThumbnails: true,
            navContainer: '.thumb-slider',
            controls: true,
            prevButton: '#prev_button',
            nextButton: '#next_button'
        });

        const thumbSlider = tns({
            loop: false,
            container: '.thumb-slider',
            items: 4,
            mouseDrag: true,
            nav: false,
            controls: false,
        });
    }

    private static _constructLightGallery(container: JQuery): void {

        container.lightGallery({
            download: false,
            share: false,
            rotate: false,
            autoplay: false,
            thumbnail: false,
            toogleThumb: false,
            animateThumb: false,
            youtubePlayerParams: {
                rel: 0,
            },
        });
    }

    private static _assignDataSrcToImageParents(imgs: JQuery): void {

        imgs.each(function () {
            let img = $(this);
            if (!img.hasClass('video')) {
                let parent = img.parent();
                parent.attr('data-src', img.attr('src') ?? '');
            }
        });
    }

    private static _initLightGalleryGloves(): void {

        const imagesContainer = $('#images-slider');
        const imgs = imagesContainer.find('img');
        const btnGallery = $('.enlarge');

        this._assignDataSrcToImageParents(imgs);

        imgs.on('click', function (e: JQuery.ClickEvent) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass('video')) {
                const imgActive = $('#images-slider .tns-slide-active');
                imgActive.trigger('click');
            }
        });

        btnGallery.on('click', function (e: JQuery.ClickEvent) {
            e.stopPropagation();
            const imgActive = $('#images-slider .tns-slide-active');
            imgActive.trigger('click');
        });

        this._constructLightGallery(imagesContainer);
    }

    private static _initLightGalleryClothes(): void {

        const imagesContainer = $('#images-grid');
        const imgs = imagesContainer.find('img');

        this._assignDataSrcToImageParents(imgs);
        this._constructLightGallery(imagesContainer);
    }
}
